import { useEffect, useState } from "react";
import { Observable, tap } from "rxjs";

export const useSubscribeObservable = <T>(observable$: Observable<T>) => {
  const [state, setState] = useState<T | undefined>(undefined);
  useEffect(() => {
    const subscription = observable$
      .pipe(tap((state) => setState(state)))
      .subscribe();
    return () => {
      subscription.unsubscribe();
    };
  }, [observable$]);
  return state;
};
